import React, {createContext, useReducer} from 'react'
import {PickReducer} from "../reducers/PickReducer";

export const PickContext = createContext();

const PickContextProvider = (props) => {
    const state = {
        totalPackages: "0",
        totalRoutes: "0",
        routeNotAssigned: "0",
        routeInProgress: "0",
        sidelinedPackages: "0",
        routePicked: "0",
        averagePickTime: "-",
        routeList: [],
        lastUpdated: null,
        picklistsInAisleGroups: [],
        picklistsInWorkGroups: [],
    }
    const [ viewModel, dispatch ] = useReducer(PickReducer, state);
    return (
        <PickContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </PickContext.Provider>
    )
}

export default PickContextProvider


// WEBPACK FOOTER //
// ./src/components/pickStatus/context/PickContext.js